module.exports = __webpack_public_path__ + "static/media/dollar.f865a890.svg";